
export function setArea(name, value) {
    const width = value.width
    const height = value.height
    const radius = (width * width) / (8 * height) + height / 2;
    switch (name) {
        case 'Треугольник':
            return (0.5 * value.width * value.height).toFixed(2)
        case 'Прямоугольник':
            return (value.width * value.height).toFixed(2)
        case 'Полукруг':
            // eslint-disable-next-line no-case-declarations
            let area = radius * radius * Math.acos((radius - height) / radius) -
                (radius - height) * Math.sqrt(radius * radius - (radius - height) * (radius - height))
            return area.toFixed(2)
            // return ((Math.PI * (value.width / 2) * (value.width / 2))).toFixed(2)
        case 'Круг':
            return (Math.PI * (value.width / 2) * (value.width / 2)).toFixed(2)
        default:
            throw new Error('Неизвестная фигура: ' + name)
    }
}
export async function setLongRing(value, radius) {
    return (value.height * 4) + 3* radius
}

/**
 * Форматирует число с разделителями тысяч
 * @param {number|string} price - Цена для форматирования
 * @returns {string} Отформатированная цена с разделителями тысяч (пробел)
 * @example
 * formatPrice(1000) // "1 000"
 * formatPrice(1234567.89) // "1 234 567.89"
 * formatPrice("5000") // "5 000"
 */
export function formatPrice(price) {
    if (price === null || price === undefined || price === '') {
        return '0'
    }
    
    // Преобразуем в число
    const numPrice = typeof price === 'string' ? parseFloat(price) : price
    
    if (isNaN(numPrice)) {
        return '0'
    }
    
    // Разделяем целую и дробную части
    const parts = numPrice.toString().split('.')
    const integerPart = parts[0]
    const decimalPart = parts[1]
    
    // Добавляем пробелы для разделения тысяч
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    
    // Возвращаем результат с дробной частью, если она есть
    return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger
}
